import {
  AuthenticationContext,
  SessionContext,
  Account,
  Session,
  SignOutButton,
  AccountPopoverFooter,
  AccountPreview,
} from '@toolpad/core';
import { Divider } from '@mui/material';

import { useAuth } from '@carcareers/hooks';
import { AccountSettingsMenuItem } from './AccountSettingsMenuItem';
import { AccountProfileMenuItem } from './AccountProfileMenuItem';

export const MenuItems = () => {
  return (
    <>
      <AccountPreview variant="expanded" />
      <Divider sx={{ my: 1 }} />
      <AccountProfileMenuItem />
      <AccountSettingsMenuItem />
      <Divider sx={{ my: 1 }} />
      <AccountPopoverFooter>
        <SignOutButton />
      </AccountPopoverFooter>
    </>
  );
};

export const AccountMenu = () => {
  const auth = useAuth();

  return (
    <AuthenticationContext.Provider value={auth}>
      <SessionContext.Provider value={auth.session as Session}>
        <Account
          slots={{
            popoverContent: MenuItems,
          }}
          slotProps={{
            signInButton: {
              variant: 'contained',
              color: 'secondary',
            },
          }}
        />
      </SessionContext.Provider>
    </AuthenticationContext.Provider>
  );
};
